import { axInstBasic } from "../../../components/Service/Service";

export const ssoData = async (searchData) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sso`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const ssoCsrData = async (searchData) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ssoCsr`,{searchData}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const ssoCacData = async (searchData) => {
  // console.log(searchData,'-------------');
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ssoCac`,{searchData}
    );
    // console.log(res,'--------------');
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
